const pisOfflineAudio = {
  bindings: {},
  templateUrl: '/modules/pis-tool/offline-audio/offline-audio.html',
  controller: 'PISOfflineAudioController',
};

angular
  .module('offline.module', [])
  .component('pisOfflineAudio', pisOfflineAudio)
  .config(function($stateProvider) {
    $stateProvider.state('pis.offline', {
      url: '/offline-audio',
      views: {
        'pisview@pis': 'pisOfflineAudio',
      },
    });
  });
